import {isMarkdown, toHTML} from '~/utils';
import {Link} from '../Link';
import * as marked from 'marked';
import { renderMarkDown } from '~/lib/utils';

const ImageDetail = ({
  image,
  content = '',
  image_left,
  title,
  cta_link,
  cta_label,
}: {
  image: string;
  content: string;
  image_left: boolean;
  title: string;
  cta_link?: string;
  cta_label?: string;
}) => {
  const renderImage = () => {
    return (
      <div className="col-lg-6 features-details-image">
        <img
          src={image}
          className="animate__animated animate__fadeInUp"
          alt="image"
        />
      </div>
    );
  };
  return (
    <div
      className={`features-details-area ptb-80 ${
        image_left ? '' : 'bg-f7fafd'
      }`}
    >
      <div className="container">
        <div className="row align-items-center">
          {image_left ? <>{renderImage()}</> : null}
          <div className={`col-lg-6 features-details`}>
            <div className="features-details-desc">
              <h3>{title}</h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: isMarkdown(content)
                    ? renderMarkDown(content)
                    : toHTML(content),
                }}
              ></div>
              {cta_link && cta_link !== ' ' ? (
                <Link to={cta_link || ''} className="btn btn-primary cta">
                  {cta_label}
                </Link>
              ) : null}
            </div>
          </div>
          {!image_left ? <>{renderImage()}</> : null}
        </div>
      </div>
    </div>
  );
};

export default ImageDetail;
